import React from "react";
import { Link } from "react-router-dom";
import NotFoundSVG from "./NotFoundSVG";

const NotFound = () => {
  return (
    // Rendered without the auth header, so the 404 owns its own themed
    // full-page surface instead of sitting on the bare body gradient.
    <div className="app-page flex min-h-screen items-center justify-center px-4 py-12">
      <div className="app-card flex w-full max-w-3xl flex-col items-center gap-6 rounded-[2rem] border p-8 text-center sm:flex-row sm:p-12 sm:text-left">
        <div className="w-48 shrink-0 sm:w-64">
          <NotFoundSVG />
        </div>

        <div className="flex flex-col items-center sm:items-start">
          <p className="app-eyebrow">Error 404</p>
          <h1 className="mt-1 text-4xl font-bold tracking-tight sm:text-5xl">
            Page not found
          </h1>
          <p className="app-muted mt-3 max-w-sm">
            The link may be old or mistyped. Head home, or search the Help &amp;
            FAQ for the page you were after.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2 sm:justify-start">
            <Link to="/" className="app-btn app-btn-primary">
              Go to Home
            </Link>
            <Link to="/help" className="app-btn app-btn-secondary">
              Help &amp; FAQ
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
